var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnglandIcon = function SvgEnglandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#england-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M27.882 12.174H15.826V.119a14.1 14.1 0 0 0-3.652 0v12.055H.119a14.1 14.1 0 0 0 0 3.652h12.055v12.055a14.1 14.1 0 0 0 3.652 0V15.827h12.055a14.1 14.1 0 0 0 0-3.652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "england-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgEnglandIcon;